import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import API_URLS from "../config/apiConfig";
import swal from "sweetalert";
import CourseSidebar from "./CourseSidebar";
import PageForm from "./PageForm";
import ChapterForm from "./ChapterForm";

const CourseChapterForm = () => {
  const authToken = localStorage.getItem("token");
  const location = useLocation();
  const [courses, setCourses] = useState([]);
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [selectedPage, setSelectedPage] = useState(null);
  const queryParams = new URLSearchParams(location.search);

  const fetchCourseDetails = async () => {
    const course_id = queryParams.get("course_id");
    try {
      const response = await axios.post(
        `${API_URLS.COURSES_FULL_DETAIL}?course_id=${course_id}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.data.success === 1) {
        setCourses(response.data.courseData || []);
        if(selectedChapter==null && selectedPage==null){
        const firstPage =
        response.data.courseData[0]?.chapters[0]?.pages[0] || null;
        setSelectedPage(firstPage);
        }
      } else {
        swal("Error", response.data.message, "error");
      }
    } catch (error) {
      console.error("Error fetching course details:", error);
    }
  };

  useEffect(() => {
    fetchCourseDetails();
  }, []);

  const handleChapterSelect = (chapter) => {

    if (selectedChapter?.id === chapter.id) {
      // If the same chapter is selected, ensure re-render
      setSelectedChapter(null); // Temporarily set to null
      setTimeout(() => setSelectedChapter(chapter), 0); // Set it back after a moment
    } else {
      // New chapter selected
      setSelectedChapter(chapter);
    }
    setSelectedPage(null); 
  };

  const handlePageSelect = (page) => {   
    if (selectedPage?.id === page.id) {
      // If the same chapter is selected, ensure re-render
      setSelectedPage(null); // Temporarily set to null
      setTimeout(() => setSelectedPage(page), 10); // Set it back after a moment
    } else {
      // New chapter selected
      setSelectedPage(page);
    }
 
    setSelectedChapter(null); // Clear selected chapter when a page is selected
  };
  const handleAddChapter = (courseId) => {
    const newChapter = {
      id: Date.now(), // Temporary ID
      chapter_name: "New Chapter",
      course_id:courseId,
      media_type:"Image",
      pages: [],
    };

    setCourses((prevCourses) =>
      prevCourses.map((course) =>
        course.id === courseId
          ? { ...course, chapters: [...course.chapters, newChapter] }
          : course
      )
    );
  };

  const handleAddPage = (chapterId) => {
    const courseId = queryParams.get("course_id");
    const newPage = {
      id: Date.now(), // Temporary ID
      course_id:courseId,
      chapter_id:chapterId,
      page_number:null,
      title: "New Page",
      media_type:"Image",
      description:"",
      uploaded_file:"",
      iframe:"",
    };

    setCourses((prevCourses) =>
      prevCourses.map((course) => ({
        ...course,
        chapters: course.chapters.map((chapter) =>
          chapter.id === chapterId
            ? { ...chapter, pages: [...chapter.pages, newPage] }
            : chapter
        ),
      }))
    );
  };

  return (
    <div className="container-fluid">
      <div className="row mt-4">
        <CourseSidebar
          courses={courses}
          onChapterSelect={handleChapterSelect}
          onPageSelect={handlePageSelect}
          onAddChapter={handleAddChapter}
          onAddPage={handleAddPage}
          selectedChapter={selectedChapter}
          selectedPage={selectedPage}
        />
        <>
          {selectedChapter && (
            <ChapterForm
              selectedChapter={selectedChapter}
              onUpdate={() => fetchCourseDetails()} // Fetch details after update
            />
          )}
          {selectedPage && (
            <PageForm
              selectedPage={selectedPage}
              onUpdate={() => fetchCourseDetails()} // Fetch details after update
            />
          )}
        </>
      </div>
    </div>
  );
};
export default CourseChapterForm;